export const blockIconsSocialPersonNew = (
	<span className='material-symbols-outlined'>person</span>
);
